import { render } from "./TherapyAdherence.vue?vue&type=template&id=32808d6e&scoped=true"
import script from "./TherapyAdherence.vue?vue&type=script&lang=js"
export * from "./TherapyAdherence.vue?vue&type=script&lang=js"

import "./TherapyAdherence.vue?vue&type=style&index=0&id=32808d6e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32808d6e"]])

export default __exports__